// JsFromRoutes CacheKey f613827804d4b5ed8556545b51737c6e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/admin/inspect/:id'),
  collection: /* #__PURE__ */ definePathHelper('get', '/admin/inspect/:id/:collection'),
}
